import { ENTITY_CONFIGS } from '@/shared/constants/entities';

export const getBreadcrumbLabel = (
  path: string,
  pathNames: string[],
  index: number,
  customLabels?: Record<string, string>,
): string | null => {
  if (customLabels && customLabels[path] !== undefined) {
    return customLabels[path] || null;
  }

  const entityConfig = Object.values(ENTITY_CONFIGS).find((config) => config.name === path);
  if (entityConfig) {
    return entityConfig.displayName;
  }

  if (path === 'new') {
    return 'Create New';
  }
  if (path === 'edit') {
    return null;
  }
  if (path === 'details') {
    return 'Details';
  }
  if (!isNaN(Number(path))) {
    const nextPath = pathNames[index + 1];
    if (nextPath === 'details') {
      return null;
    }
    return 'Edit';
  }

  if (path.includes('-')) {
    return path
      .split('-')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  return path.charAt(0).toUpperCase() + path.slice(1);
};

export const getBreadcrumbPath = (pathNames: string[], index: number): string => {
  const basePath = `/${pathNames.slice(0, index + 1).join('/')}`;
  const value = pathNames[index];
  if (isNaN(Number(value))) return basePath;
  const nextPath = pathNames[index + 1];
  if (nextPath === 'edit') return `${basePath}/edit`;
  if (nextPath === 'details') return `${basePath}/details`;
  if (!nextPath) {
    const prevPath = pathNames[index - 1];
    if (prevPath === 'replacement-batches' || prevPath === 'removal-batches') {
      return `${basePath}/details`;
    }
  }
  return basePath;
};
